<template>
  <div>
    <GoBackView />
    <div class="pro-info" style="margin-bottom: 100px;">
      <DiscountProductSwipeView :item="proData" v-if="proData" />
      <DiscountProPriceView :item="proData" v-if="proData" />
      <DiscountProDesc :item="proData" v-if="proData" />
    </div>
    <DiscountProBtnView />
  </div>
</template>

<script>
import GoBackView from '@/components/goback/index.vue'
import {
  DiscountProductSwipeView,
  DiscountProDesc,
  DiscountProPriceView,
  DiscountProBtnView
} from './components/index'
export default {
  name: 'DiscountItemInfoView',
  components: {
    GoBackView,
    DiscountProductSwipeView,
    DiscountProDesc,
    DiscountProPriceView,
    DiscountProBtnView
  },
  data () {
    return {
      proData: null,
      proid: 995,
      auction: null,
      timer: null
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  mounted () {
    //this.proid = this.$route.query.id
    //if (this.proid) {
    this.getData()
    //}
  },
  methods: {
    async getData () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      await this.$http({
        method: 'post',
        url: 'getProductDetail',
        data: { id: this.proid }
      })
        .then(res => {
          this.$toast.clear()
          this.proData = res.data
          if (this.proData.is_auction_end == 0) {
            const that = this
            this.$nextTick(() => {
              that.timer = setInterval(() => {
                // that.getDataInter()
              }, 5000)
            })
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.pro-info {
  margin: 10px 10px 10px;
  padding: 15px 10px 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
}
</style>
